import { entityTypeNameFor } from "@shapeable/utils";
import { usePageEntity } from "./use-page-entity";
import { useSite } from "./use-site";
import { useActiveEntityType } from "./use-active-entity-type";
export var useExplorerParentView = function () {
  var site = useSite();
  var pageEntity = usePageEntity();
  var activeEntityTypeName = useActiveEntityType();
  var entityTypeName = entityTypeNameFor(pageEntity);
  /* @ts-ignore */
  var actualEntityTypeName = entityTypeName === 'entity' ? activeEntityTypeName : entityTypeName;
  var _a = site.entityViews,
    entityViews = _a === void 0 ? [] : _a;
  // try to work out which tab is active, by finding the first view which lists the current entityTypeName in its childEntityTypes 
  var parentView = entityViews.find(function (view) {
    return (view.childEntityTypes || []).map(function (entityType) {
      return entityType.internalName || entityType.name;
    }).includes(actualEntityTypeName);
  });
  if (parentView) {
    return parentView;
  }
  return null;
};